import { render, staticRenderFns } from "./video-tag-warp.vue?vue&type=template&id=2e039bed&scoped=true&"
import script from "./video-tag-warp.vue?vue&type=script&lang=ts&"
export * from "./video-tag-warp.vue?vue&type=script&lang=ts&"
import style0 from "./video-tag-warp.vue?vue&type=style&index=0&id=2e039bed&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e039bed",
  null
  
)

export default component.exports